import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productos-promociones',
  templateUrl: './productos-promociones.component.html',
  styleUrls: ['./productos-promociones.component.scss']
})
export class ProductosPromocionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
